import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "tinyOffset5": "login-360fc939-tinyOffset5-WXUgJq",
  "default7": "login-360fc939-default7-WXUgJq",
  "tinyOffset11": "login-360fc939-tinyOffset11-WXUgJq",
  "confined7": "login-360fc939-confined7-WXUgJq",
  "col": "login-360fc939-col-WXUgJq",
  "defaultOffset9": "login-360fc939-defaultOffset9-WXUgJq",
  "row": "login-360fc939-row-WXUgJq",
  "xwide7": "login-360fc939-xwide7-WXUgJq",
  "wide10": "login-360fc939-wide10-WXUgJq",
  "wide11": "login-360fc939-wide11-WXUgJq",
  "xwideOffset9": "login-360fc939-xwideOffset9-WXUgJq",
  "confined9": "login-360fc939-confined9-WXUgJq",
  "xwide5": "login-360fc939-xwide5-WXUgJq",
  "confined6": "login-360fc939-confined6-WXUgJq",
  "tiny4": "login-360fc939-tiny4-WXUgJq",
  "tinyOffset6": "login-360fc939-tinyOffset6-WXUgJq",
  "tiny8": "login-360fc939-tiny8-WXUgJq",
  "tinyOffset7": "login-360fc939-tinyOffset7-WXUgJq",
  "wideOffset8": "login-360fc939-wideOffset8-WXUgJq",
  "tinyOffset10": "login-360fc939-tinyOffset10-WXUgJq",
  "tiny6": "login-360fc939-tiny6-WXUgJq",
  "confinedOffset6": "login-360fc939-confinedOffset6-WXUgJq",
  "default5": "login-360fc939-default5-WXUgJq",
  "confined4": "login-360fc939-confined4-WXUgJq",
  "wideOffset0": "login-360fc939-wideOffset0-WXUgJq",
  "confined8": "login-360fc939-confined8-WXUgJq",
  "xwideOffset2": "login-360fc939-xwideOffset2-WXUgJq",
  "confinedOffset7": "login-360fc939-confinedOffset7-WXUgJq",
  "defaultOffset10": "login-360fc939-defaultOffset10-WXUgJq",
  "confinedOffset4": "login-360fc939-confinedOffset4-WXUgJq",
  "tinyOffset1": "login-360fc939-tinyOffset1-WXUgJq",
  "confinedOffset10": "login-360fc939-confinedOffset10-WXUgJq",
  "wide8": "login-360fc939-wide8-WXUgJq",
  "wideOffset1": "login-360fc939-wideOffset1-WXUgJq",
  "xwide10": "login-360fc939-xwide10-WXUgJq",
  "xwide2": "login-360fc939-xwide2-WXUgJq",
  "confined10": "login-360fc939-confined10-WXUgJq",
  "confinedOffset3": "login-360fc939-confinedOffset3-WXUgJq",
  "tiny10": "login-360fc939-tiny10-WXUgJq",
  "wideOffset6": "login-360fc939-wideOffset6-WXUgJq",
  "wide4": "login-360fc939-wide4-WXUgJq",
  "xwideOffset8": "login-360fc939-xwideOffset8-WXUgJq",
  "xwideOffset10": "login-360fc939-xwideOffset10-WXUgJq",
  "xwide6": "login-360fc939-xwide6-WXUgJq",
  "confined11": "login-360fc939-confined11-WXUgJq",
  "tiny1": "login-360fc939-tiny1-WXUgJq",
  "default2": "login-360fc939-default2-WXUgJq",
  "defaultOffset6": "login-360fc939-defaultOffset6-WXUgJq",
  "confined1": "login-360fc939-confined1-WXUgJq",
  "wide6": "login-360fc939-wide6-WXUgJq",
  "xwideOffset0": "login-360fc939-xwideOffset0-WXUgJq",
  "wide9": "login-360fc939-wide9-WXUgJq",
  "xwideOffset3": "login-360fc939-xwideOffset3-WXUgJq",
  "tiny12": "login-360fc939-tiny12-WXUgJq",
  "tiny3": "login-360fc939-tiny3-WXUgJq",
  "wide12": "login-360fc939-wide12-WXUgJq",
  "default10": "login-360fc939-default10-WXUgJq",
  "xwideOffset6": "login-360fc939-xwideOffset6-WXUgJq",
  "defaultOffset5": "login-360fc939-defaultOffset5-WXUgJq",
  "confinedOffset1": "login-360fc939-confinedOffset1-WXUgJq",
  "gridContainer": "login-360fc939-gridContainer-WXUgJq",
  "defaultOffset11": "login-360fc939-defaultOffset11-WXUgJq",
  "xwide9": "login-360fc939-xwide9-WXUgJq",
  "wideGridContainer": "login-360fc939-wideGridContainer-WXUgJq",
  "wideOffset7": "login-360fc939-wideOffset7-WXUgJq",
  "confined0": "login-360fc939-confined0-WXUgJq",
  "tinyOffset9": "login-360fc939-tinyOffset9-WXUgJq",
  "default4": "login-360fc939-default4-WXUgJq",
  "tinyOffset8": "login-360fc939-tinyOffset8-WXUgJq",
  "xwide4": "login-360fc939-xwide4-WXUgJq",
  "wide7": "login-360fc939-wide7-WXUgJq",
  "xwideOffset11": "login-360fc939-xwideOffset11-WXUgJq",
  "wide0": "login-360fc939-wide0-WXUgJq",
  "confined12": "login-360fc939-confined12-WXUgJq",
  "wideOffset10": "login-360fc939-wideOffset10-WXUgJq",
  "confinedOffset2": "login-360fc939-confinedOffset2-WXUgJq",
  "confined2": "login-360fc939-confined2-WXUgJq",
  "armstrongGridContainer": "login-360fc939-armstrongGridContainer-WXUgJq",
  "wide5": "login-360fc939-wide5-WXUgJq",
  "confinedOffset5": "login-360fc939-confinedOffset5-WXUgJq",
  "default11": "login-360fc939-default11-WXUgJq",
  "confinedOffset8": "login-360fc939-confinedOffset8-WXUgJq",
  "default12": "login-360fc939-default12-WXUgJq",
  "tiny9": "login-360fc939-tiny9-WXUgJq",
  "tinyOffset4": "login-360fc939-tinyOffset4-WXUgJq",
  "confinedOffset11": "login-360fc939-confinedOffset11-WXUgJq",
  "xwideOffset1": "login-360fc939-xwideOffset1-WXUgJq",
  "defaultOffset1": "login-360fc939-defaultOffset1-WXUgJq",
  "wide1": "login-360fc939-wide1-WXUgJq",
  "xwide8": "login-360fc939-xwide8-WXUgJq",
  "confined5": "login-360fc939-confined5-WXUgJq",
  "default3": "login-360fc939-default3-WXUgJq",
  "tiny11": "login-360fc939-tiny11-WXUgJq",
  "tiny5": "login-360fc939-tiny5-WXUgJq",
  "wide2": "login-360fc939-wide2-WXUgJq",
  "xwide0": "login-360fc939-xwide0-WXUgJq",
  "confinedOffset9": "login-360fc939-confinedOffset9-WXUgJq",
  "tiny7": "login-360fc939-tiny7-WXUgJq",
  "xwide11": "login-360fc939-xwide11-WXUgJq",
  "default9": "login-360fc939-default9-WXUgJq",
  "xwideOffset7": "login-360fc939-xwideOffset7-WXUgJq",
  "wideOffset4": "login-360fc939-wideOffset4-WXUgJq",
  "wideOffset11": "login-360fc939-wideOffset11-WXUgJq",
  "defaultOffset8": "login-360fc939-defaultOffset8-WXUgJq",
  "defaultOffset7": "login-360fc939-defaultOffset7-WXUgJq",
  "tinyOffset0": "login-360fc939-tinyOffset0-WXUgJq",
  "default6": "login-360fc939-default6-WXUgJq",
  "default0": "login-360fc939-default0-WXUgJq",
  "confinedOffset0": "login-360fc939-confinedOffset0-WXUgJq",
  "xwide3": "login-360fc939-xwide3-WXUgJq",
  "defaultOffset3": "login-360fc939-defaultOffset3-WXUgJq",
  "grid": "login-360fc939-grid-WXUgJq",
  "tinyOffset3": "login-360fc939-tinyOffset3-WXUgJq",
  "xwide1": "login-360fc939-xwide1-WXUgJq",
  "xwideOffset5": "login-360fc939-xwideOffset5-WXUgJq",
  "wide3": "login-360fc939-wide3-WXUgJq",
  "default8": "login-360fc939-default8-WXUgJq",
  "wideOffset5": "login-360fc939-wideOffset5-WXUgJq",
  "xwideOffset4": "login-360fc939-xwideOffset4-WXUgJq",
  "wideOffset9": "login-360fc939-wideOffset9-WXUgJq",
  "standardGridContainer": "login-360fc939-standardGridContainer-WXUgJq",
  "defaultOffset2": "login-360fc939-defaultOffset2-WXUgJq",
  "default1": "login-360fc939-default1-WXUgJq",
  "confined3": "login-360fc939-confined3-WXUgJq",
  "wideOffset2": "login-360fc939-wideOffset2-WXUgJq",
  "xwide12": "login-360fc939-xwide12-WXUgJq",
  "tiny0": "login-360fc939-tiny0-WXUgJq",
  "tinyOffset2": "login-360fc939-tinyOffset2-WXUgJq",
  "wideOffset3": "login-360fc939-wideOffset3-WXUgJq",
  "defaultOffset4": "login-360fc939-defaultOffset4-WXUgJq",
  "tiny2": "login-360fc939-tiny2-WXUgJq"
};